const HYPERBROWSER_LIVE_URL = "https://app.hyperbrowser.ai/live";

function extractTokenFromUrl(url?: string | null) {
  if (!url) return undefined;
  try {
    const parsed = new URL(url);
    return parsed.searchParams.get("token") ?? undefined;
  } catch {
    return undefined;
  }
}

function deriveLiveHostFromWsEndpoint(wsEndpoint?: string) {
  if (!wsEndpoint) return undefined;
  try {
    const wsUrl = new URL(wsEndpoint);
    const host = wsUrl.host.startsWith("connect-")
      ? wsUrl.host.replace("connect-", "live-")
      : wsUrl.host;
    return `https://${host}`;
  } catch {
    return undefined;
  }
}

export type HyperbrowserSessionLike = {
  liveUrl?: string;
  sessionUrl?: string;
  token?: string;
  wsEndpoint?: string;
};

export function buildLiveViewUrl(session: HyperbrowserSessionLike) {
  const token = session.token ?? extractTokenFromUrl(session.sessionUrl);
  if (session.liveUrl) return session.liveUrl;
  if (token) {
    const regionLiveHost = deriveLiveHostFromWsEndpoint(session.wsEndpoint);
    if (regionLiveHost) {
      return `${regionLiveHost}/vnc.html?autoconnect=true&resize=scale&scaling=local&token=${encodeURIComponent(
        token
      )}`;
    }
    return `${HYPERBROWSER_LIVE_URL}?token=${encodeURIComponent(
      token
    )}&keepAlive=true`;
  }
  return session.sessionUrl;
}
